import {
  applyMiddleware,
  combineReducers,
  createStore,
  PreloadedState,
  compose
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import { isDevelopment, isProduction } from 'src/constants';
import documents, {
  defaultState as documentsDefaultState,
} from './document/document.reducer';

import teamMembers, {
  defaultState as teamMembersDefaultState,
} from './teamMember/teamMember.reducer';
import declarations, {
  defaultState as declarationsDefaultState,
} from './declaration/declaration.reducer';
import propertiesApplicant, {
  defaultState as propertiesApplicantDefaultState,
} from './properties/properties.reducer';
import realEstateAssets, {
  defaultState as realEstateAssetsDefaultState,
} from './realEstateAssets/realEstateAssets.reducer';

import collateral, {
  defaultState as collateralDefaultState,
} from './collateral/collateral.reducer';
import documentPointers, {
  defaultState as documentPointersDefaultState,
} from './documentPointersRole/documentpointer.reducer';
import lendingTermsApplicant, {
  defaultState as defaultLendingTermApplicantState,
} from './lendingTerms/lendingterms.reducer';
import monthlyIncome, {
  defaultState as defaultMonthlyIncomeState,
} from './monthlyIncome/monthlyIncome.reducer';
import assets, {
  defaultState as assetDefaultState,
} from 'src/store/assets/assets.reducer';
import liabilities, {
  defaultState as liabilitiesDefaultState,
} from 'src/store/liabilities/liabilities.reducer';
import additionalLoan, {
  defaultState as additionalLoanDefaultState,
} from 'src/store/additionalLoans/addLoan.reducer';
import loan_documents, {
  defaultState as loanDocumentsDefaultState,
} from 'src/store/loanPackages/loan_packs.reducer';

import accountOpenId, {
  defaultState as accountOpenIdDefaultState,
} from 'src/store/accountOpenid/accountopenid.reducer';
import loanStatus, {
  defaultState as loanStatusDefaultState,
} from 'src/store/loanStatus/loan_status.reducer';
import { ApplicationState } from './ApplicationState.d';
import accounts, {
  defaultState as accountDefaultState,
} from 'src/store/account/account.reducer';
import siteSettings, {
  defaultState as siteSettingsDefaultState,
} from 'src/store/siteSettings/siteSettings.reducer';
import business, {
  defaultState as businessDefaultState,
} from 'src/store/business/business.reducer';
/////////////////////  ADMIN
import loanappsAdmin, {
  defaultState as defaultLoanAppsAdminState,
} from 'src/store/admin/loanappsAdmin/loanappsadmin.reducer';

import employments, {
  defaultState as employmentDefaultState,
} from 'src/store/employment/employment.reducer';
////////////////////// USER SPECIFIC INTENTS
import userSpecificIntent, {
  defaultState as userSpecificIntentDefaultState,
} from 'src/store/siteConfigurator/userSpecificIntent/userSpecificIntent.reducer';

import loanappsAdvisor, {
  defaultState as defaultLoanAppsAdvisorState,
} from 'src/store/loanappsadvisor/loanappsadvisor.reducer';

import loanAppsDPAdvisor, {
  defaultState as defaultLoanAppsDPAdvisorState,
} from 'src/store/loanappDpAdvisor/loanappsaDpAdvisor.reducer';


import loanAppsCDPAdvisor, {
  defaultState as defaultLoanAppsCDPAdvisorState,
} from 'src/store/loanAppCDPQueueAdvisor/loanappsCDPAdvisor.reducer';

import loanAppsPrequalifiedAdvisor, {
  defaultState as defaultLoanAppsPrequalifedAdvisorState,
} from 'src/store/loanAppPrequalifiedQueueAdvisor/loanappsPrequalifiedAdvisor.reducer'

import loanAppsIncompleteAdvisor, {
  defaultState as defaultLoanAppsIncompleteAdvisorState,
} from 'src/store/loanAppIncompleteQueueAdvisor/loanappsIncompleteAdvisor.reducer'


import loanAppsuwAdvisor, {
  defaultState as defaultLoanAppsuwAdvisorState,
} from 'src/store/loanappUWAdvisor/loanappsaUWAdvisor.reducer';
import loanAppsFundedAdvisor, {
  defaultState as defaultLoanAppsfundedAdvisorState,
} from 'src/store/loanAppFundedAdvisor/loanappsaFundedAdvisor.reducer';
import loanAppsPendingAdvisor, {
  defaultState as defaultLoanAppsPendingAdvisorState,
} from 'src/store/loanAppPendingAdvisor/loanappsPendingAdvisor.reducer';
import loanAppsDeclinedAdvisor, {
  defaultState as defaultLoanAppsDeclinedAdvisorState,
} from 'src/store/loanAppDeclinedAdvisor/loanappsaDeclinedAdvisor.reducer';

import loanAppsWithdrawnAdvisor, {
  defaultState as defaultLoanAppsWithdrawnAdvisorState,
} from 'src/store/loanAppWithdrawnAdvisor/loanappsWithdrawnAdvisor.reducer';
import loanAppsCompletedAdvisor, {
  defaultState as defaultLoanAppsCompletedAdvisorState,
} from 'src/store/loanAppCompletedAdvisor/loanappsCompletedAdvisor.reducer';
import loanAppsDepositAccountsAdvisor, {
  defaultState as defaultLoanAppsDepositAccountsAdvisorState,
} from 'src/store/loanAppDepositAccountsAdvisor/loanappsDepositAccountsAdvisor.reducer';
import loanAppsapprovedNotAcceptedAdvisor, {
  defaultState as defaultLoanAppsapprovedNotAcceptedAdvisorState,
} from 'src/store/loanAppApprovedNotAcceptedAdvisor/loanappsapprovedNotAcceptedAdvisor.reducer';

import loanAppsArchiveAdvisor, {
  defaultState as defaultLoanAppsArchiveAdvisorState,
} from 'src/store/loanAppArchiveAdvisor/loanappsArchiveAdvisor.reducer';

import loanAppsDenialUnderReviewAdvisor, {
  defaultState as defaultLoanAppsDenialUnderReviewAdvisorState,
} from 'src/store/loanAppDenialUnderReviewAdvisor/loanappsDenialUnderReviewAdvisor.reducer';

import loanAppsCreditManagementAdvisor, {
  defaultState as defaultLoanAppsCreditManagementAdvisorState,
} from 'src/store/loanAppCreditManagementAdvisor/loanappsCreditManagementAdvisor.reducer';

import loanAppsCentralGroupAdvisor, {
  defaultState as defaultLoanAppsCentralGroupAdvisorState,
} from 'src/store/loanAppCentralGroupAdvisor/loanappsCentralGroupAdvisor.reducer';



import tasks, {
  defaultState as defaultLoanAppsTaskState,
} from 'src/store/tasks/task.reducer';

import loanApp, {
  defaultState as defaultLoanAppState,
} from 'src/store/loanapp/loanapp.reducer';
import advisorProfile, {
  defaultState as defaultAdvisorProfileState,
} from 'src/store/advisorProfile/advisorProfile.reducer';

import borrowers, {
  defaultState as borrowersDefaultState,
} from './borrower/borrower.reducer';

import applicantAccounts, {
  defaultState as applicantAccountsDefaultState,
} from './applicantAccounts/accounts.reducer';
import loanAppRoles, {
  defaultState as loanAppRolesDefaultState,
} from './loanAppRole/loanrole.reducer';

//// Global authentication reducer
import authentication, {
  defaultState as authenticationDefaultState,
} from './authentication/authentication.reducer';

import featureFlagsLoad, {
  defaultState as featureFlagsLoadState,
} from './featureFlagsLoad/featureFlagsLoad.reducer';
import mockFeatureFlags, {
  defaultMockFeatureFlagState,
} from './mockFeatureFlags';
export const pubNubDefaultState = {
  byId: {},
};
/**
 * Default State
 */

const __resourcesDefaultState = {
  business: businessDefaultState,
  teamMembers: teamMembersDefaultState,
  siteSettings: siteSettingsDefaultState,
  loanStatus: loanStatusDefaultState,
  employments: employmentDefaultState,
  loanApp: defaultLoanAppState,
  propertiesApplicant: propertiesApplicantDefaultState,
  realEstateAssets: realEstateAssetsDefaultState,
  collateral: collateralDefaultState,
  lendingTermsApplicant: defaultLendingTermApplicantState,
  monthlyIncome: defaultMonthlyIncomeState,
  tasks: defaultLoanAppsTaskState,
  assets: assetDefaultState,
  borrowers: borrowersDefaultState,
  declarations: declarationsDefaultState,
  liabilities: liabilitiesDefaultState,
  additionalLoan: additionalLoanDefaultState,
  userSpecificIntent: userSpecificIntentDefaultState,
  applicantAccounts: applicantAccountsDefaultState,
  loanAppRoles: loanAppRolesDefaultState
};

const __advisorResourcesDefaultState = {
  loanappsAdvisor: defaultLoanAppsAdvisorState,
  loanAppsDPAdvisor: defaultLoanAppsDPAdvisorState,
  loanAppsCDPAdvisor: defaultLoanAppsCDPAdvisorState,
  loanAppsPrequalifiedAdvisor: defaultLoanAppsPrequalifedAdvisorState,
  loanAppsIncompleteAdvisor: defaultLoanAppsIncompleteAdvisorState,
  loanAppsuwAdvisor: defaultLoanAppsuwAdvisorState,
  loanAppsFundedAdvisor: defaultLoanAppsfundedAdvisorState,
  loanAppsPendingAdvisor: defaultLoanAppsPendingAdvisorState,
  loanAppsDeclinedAdvisor: defaultLoanAppsDeclinedAdvisorState,
  loanAppsWithdrawnAdvisor: defaultLoanAppsWithdrawnAdvisorState,
  loanAppsCompletedAdvisor: defaultLoanAppsCompletedAdvisorState,
  loanAppsDepositAccountsAdvisor: defaultLoanAppsDepositAccountsAdvisorState,
  loanAppsapprovedNotAcceptedAdvisor:
    defaultLoanAppsapprovedNotAcceptedAdvisorState,
  loanAppsArchiveAdvisor:
    defaultLoanAppsArchiveAdvisorState,
  loanAppsDenialUnderReviewAdvisor:
    defaultLoanAppsDenialUnderReviewAdvisorState,
  loanAppsCreditManagementAdvisor:
    defaultLoanAppsCreditManagementAdvisorState,
  loanAppsCentralGroupAdvisor:
    defaultLoanAppsCentralGroupAdvisorState,
  advisorProfile: defaultAdvisorProfileState
};
const __adminResourcesDefaultState = {
  loanappsAdmin: defaultLoanAppsAdminState,
};

/**
 * Reducers
 */

const __resources = combineReducers({
  propertiesApplicant,
  collateral,
  realEstateAssets,
  teamMembers,
  siteSettings,
  loanStatus,
  employments,
  loanApp,
  lendingTermsApplicant,
  monthlyIncome,
  tasks,
  assets,
  borrowers,
  business,
  declarations,
  liabilities,
  additionalLoan,
  userSpecificIntent,
  applicantAccounts,
  loanAppRoles
});

const __advisorResources = combineReducers({
  loanappsAdvisor,
  loanAppsDPAdvisor,
  loanAppsPrequalifiedAdvisor,
  loanAppsIncompleteAdvisor,
  loanAppsCDPAdvisor,
  loanAppsuwAdvisor,
  loanAppsFundedAdvisor,
  loanAppsPendingAdvisor,
  loanAppsDeclinedAdvisor,
  loanAppsWithdrawnAdvisor,
  loanAppsCompletedAdvisor,
  loanAppsDepositAccountsAdvisor,
  loanAppsapprovedNotAcceptedAdvisor,
  loanAppsArchiveAdvisor,
  loanAppsDenialUnderReviewAdvisor,
  loanAppsCreditManagementAdvisor,
  loanAppsCentralGroupAdvisor,
  advisorProfile
});

const __adminResources = combineReducers({
  loanappsAdmin,
});

export const defaultState: ApplicationState = {
  __resources: __resourcesDefaultState,
  __advisorResources: __advisorResourcesDefaultState,
  __adminResources: __adminResourcesDefaultState,
  authentication: authenticationDefaultState,
  accounts: accountDefaultState,
  /// The below must move to Resources State
  featureFlagsLoad: featureFlagsLoadState,
  mockFeatureFlags: defaultMockFeatureFlagState,
  documents: documentsDefaultState,
  documentPointers: documentPointersDefaultState,
  loan_documents: loanDocumentsDefaultState,
  accountOpenId: accountOpenIdDefaultState
};

const reducers = combineReducers<ApplicationState>({
  __resources,
  __advisorResources,
  __adminResources,
  authentication,
  accounts,
  documentPointers,
  documents,
  loan_documents,
  accountOpenId,
  featureFlagsLoad,
  mockFeatureFlags
});

const enhancersDebug = composeWithDevTools(
  /* middleware works indpendly wrt t other middlewares,
  but sometimes its order is making some error,so keeping
  pubnub reducers at first to avoid that
  */
  applyMiddleware(
    thunk,
    createLogger({
      level: !isProduction ? 'log' : 'error',
      collapsed: (getState: () => any, action: any, logEntry: any) =>
        !logEntry.error,
      diff: true,
    })
  )
);

export const setupStore = (preloadedState?: PreloadedState<ApplicationState>) => {
  return createStore(
    reducers,
    preloadedState
  )
}

const enhancers = compose(applyMiddleware(thunk));
const enchancersFn = isDevelopment ? enhancersDebug : enhancers;
const store =  createStore(reducers, defaultState, enchancersFn);

export default store